import { render, staticRenderFns } from "./gamelist_v4.vue?vue&type=template&id=77d64b9f&scoped=true"
import script from "./gamelist_v4.vue?vue&type=script&lang=js"
export * from "./gamelist_v4.vue?vue&type=script&lang=js"
import style0 from "./gamelist_v4.vue?vue&type=style&index=0&id=77d64b9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d64b9f",
  null
  
)

export default component.exports